import React from "react";
import MediaQuery from "react-responsive";
import PropTypes from "prop-types";
export default class DesktopOnly extends React.Component {
  render() {
    return <MediaQuery minWidth={1024}>{this.props.children}</MediaQuery>;
  }
}

DesktopOnly.propTypes = { children: PropTypes.element.isRequired };
